import { ComponentProps } from "react";

import { InputBox } from "@design-system/InputBox/InputBox";
import { Textarea } from "@design-system/Textarea/Textarea";

type Props = ComponentProps<typeof Textarea>;

export const MultiLineTextField = (props: Props) => {
  return (
    <InputBox>
      <Textarea {...props} />
    </InputBox>
  );
};
